module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kt7Um"))).then(() => parcelRequire('3a9aZ'));